import axios from 'axios'

import './axiosAuthMiddleware'
import { errorMiddleware } from './errorMiddleware'
import { OauthRequestData } from '@/interfaces/oauth'
import { environment } from '@/shared/consts/environment'

const apiUrl = `${environment.apiUrl}/api/v1`
// const apiUrl = `https://creatorland-backend-pxmravg2gq-uc.a.run.app/api/v1`
/**
 * ----------------------------------------
 * Get general status
 * ----------------------------------------
 */

// ---
export const getOauthGeneralStatus = async (id: string) => {
  try {
    const res = await axios.get(
      `${apiUrl}/oauth-general/oauth-connection-status?id=${id}`
    )
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Google (get url)
 * ----------------------------------------
 */

// ---
export const getGoogleUrl = async () => {
  try {
    const res = await axios.get(`${apiUrl}/youtube`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Checking If the user has gmail oauth connected successfully
 * ----------------------------------------
 */

export const getGoogleConnectedStatus = async () => {
  try {
    const res = await axios.get(`${apiUrl}/youtube/gmail-connection-status`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Google (get gmail signed url)
 * ----------------------------------------
 */

export const getGmailSignedUrl = async () => {
  try {
    const res = await axios.get(`${apiUrl}/youtube/gmail-signed-url`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

// Invite Future Contacts Automatically
// "Enable Auto Connect",
export const updateDealSyncInviteSettings = async (
  automaticInvites: boolean
) => {
  try {
    const res = await axios.put(
      `${apiUrl}/youtube/dealsync-auto-invite-setting`,
      {
        automaticInvites,
      }
    )
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Check 5 digit code
 * ----------------------------------------
 */

export const getDealsyncBetaAccessStatus5DigitCode = async (code: number) => {
  try {
    const res = await axios.get(
      `${apiUrl}/youtube/dealsync-beta-access-status/${code}`
    )
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Send google info
 * ----------------------------------------
 */
export const connectGoogleAccount = async (data: OauthRequestData) => {
  try {
    // https://creatorland-backend-360321061826.us-central1.run.app/api/v1/youtube trigger this from local for succesfull auth
    // latest staging: https://creatorland-backend-pxmravg2gq-uc.a.run.app
    const res = await axios.post(`${apiUrl}/youtube`, data)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Disconnect google info
 * ----------------------------------------
 */
export const disconnectGoogleAccount = async () => {
  try {
    const res = await axios.post(`${apiUrl}/youtube/revoke-connection`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Tiltok (get url)
 * ----------------------------------------
 */

// ---
export const getTiktokUrl = async () => {
  try {
    const res = await axios.get(`${apiUrl}/tiktok`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Send tiktok info
 * ----------------------------------------
 */
export const connectTiktokAccount = async (data: OauthRequestData) => {
  try {
    const res = await axios.post(`${apiUrl}/tiktok`, data)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Disconnect tiktok info
 * ----------------------------------------
 */
export const disconnectTikTokAccount = async () => {
  try {
    const res = await axios.post(`${apiUrl}/tiktok/revoke-connection`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Instagram (get url)
 * ----------------------------------------
 */
export const getInstagramUrl = async () => {
  try {
    const res = await axios.get(`${apiUrl}/instagram`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
export const getinstagramBasicUrl = async () => {
  try {
    const res = await axios.get(`${apiUrl}/instagram-basic`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Send instagram info
 * ----------------------------------------
 */
export const connectInstagramAccount = async (data: OauthRequestData) => {
  try {
    const res = await axios.post(`${apiUrl}/instagram`, data)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const connectInstagramBasicAccount = async (data: OauthRequestData) => {
  try {
    const res = await axios.post(`${apiUrl}/instagram-basic`, data)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
/**
 * ----------------------------------------
 * Disconnect instagram info
 * ----------------------------------------
 */
export const disconnectInstagram = async () => {
  try {
    const res = await axios.post(`${apiUrl}/instagram/revoke-connection`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const disconnectinstagramBasic = async () => {
  try {
    const res = await axios.post(`${apiUrl}/instagram-basic/revoke-connection`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
